import { useState, useEffect, useRef } from "react";
import { setFocus } from "@noriginmedia/norigin-spatial-navigation";
import { FIRST_EVENT_KEY } from "../constants/event";
import { trackPendoEvent } from "../utils/shared/pendo";
import { isConnected, pauseLiveContent, playLiveContent } from "../../Upshow";
import { getModel } from "../../utils/models";

function notifyEPGState(isOpen) {
    window.dispatchEvent(new CustomEvent('EPGStateUpdate', { detail: { isOpen } }));
}

export default function useEPGState(resetFilter, deeplinkEventIdUrl, orgShouldCheckToSignTC) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [focusKeyToReturn, setFocusKeyToReturn] = useState(null);
    const [deeplinkEventId, setDeeplinkEventId] = useState(deeplinkEventIdUrl);
    const shouldSignXumoTC = window.__UpshowState && !!window.__UpshowState.xumoTermsAndConditions?.shouldSign;
    const [showTermsPopup, setShowTermsPopup] = useState(false);
    const isOpenRef = useRef(isOpen);
    isOpenRef.current = isOpen;

    useEffect(() => {
        const answerEPGStateQuery = (e) => { e.detail.isOpen = isOpenRef.current; };
        window.addEventListener('EPGStateQuery', answerEPGStateQuery);
        return () => window.removeEventListener('EPGStateQuery', answerEPGStateQuery);
    }, []);


    const isXumo = getModel().startsWith('xumo');

    const openEPG = () => {
        if (!isConnected()) return;

        if (orgShouldCheckToSignTC) {
            if (!shouldSignXumoTC) {
                setIsOpen(true);
                notifyEPGState(true);
            }else {
                setShowTermsPopup(true);
            }
        }
        else {
            setIsOpen(true);
            notifyEPGState(true);
        }

        if (isXumo) pauseLiveContent();

        trackPendoEvent('Open EPG');
    };

    const closeEPG = () => {
        // Reset all states
        setIsOpen(false);
        setSelectedEvent(null);
        setFocusKeyToReturn(null);
        resetFilter();
        setFocus(FIRST_EVENT_KEY);
        setDeeplinkEventId(null);
        setShowTermsPopup(false);

        if (isXumo) playLiveContent();

        // Notify Android App that EPG has closed
        if (window.UPshowAndroidApp && window.UPshowAndroidApp.epgClosed) {
            window.UPshowAndroidApp.epgClosed();
        }

        notifyEPGState(false);

        // Pendo tracking
        trackPendoEvent('Close EPG');
    };

    const clearSelection = () => {
        setSelectedEvent(null);

        if (focusKeyToReturn) {
            setFocus(focusKeyToReturn);
        }
        setFocusKeyToReturn(null);
        setDeeplinkEventId(null);
    };

    return {
        isOpen,
        selectedEvent,
        focusKeyToReturn,
        deeplinkEventId,
        shouldSignXumoTC,
        showTermsPopup,
        setShowTermsPopup,
        openEPG,
        closeEPG,
        clearSelection,
        setSelectedEvent,
        setFocusKeyToReturn,
    };
}
